<template>
  <div>
    <a-modal
      :visible="open"
      @cancel="handleCancel"
      :footer="null"
      style="top: 230px"
      width="418px"
      :maskClosable="false"
    >
      <div class="modal-login vcode-content">
        <div class="modal-login-title">登录</div>
        <a-form
          class="login-form"
          :model="formState"
          name="basic"
          :hideRequiredMark="true"
          autocomplete="off"
          @finish="handleSubmit"
          ref="loginFormRef"
        >
          <a-form-item
            name="tel"
            :rules="[
              { required: true, validator: handleCheckPhone, trigger: 'blur' },
            ]"
          >
            <a-input
              class="phone-input"
              v-model:value="formState.tel"
              placeholder="请输入手机号"
            />
          </a-form-item>
          <a-form-item
            name="code"
            :rules="[
              { required: true, validator: handleCheckCode, trigger: 'blur' },
            ]"
          >
            <div class="code-wrapper">
              <a-input
                v-model:value="formState.code"
                placeholder="请输入验证码"
                class="code-input"
                :bordered="false"
              />
              <a-button
                @click="handleSendCode"
                size="middle"
                type="link"
                class="send-code"
                :disabled="seconds < 120"
                >{{ btnText }}</a-button
              >
            </div>
          </a-form-item>
          <a-button
            class="btn"
            html-type="submit"
            type="primary"
            :disabled="codeSubmitFlag"
            >登录</a-button
          >
          <div class="tip">未注册用户验证后将自动注册</div>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>
<script setup>
import { defineProps, ref, reactive } from "vue";
import store from "@/store";
import { message } from "ant-design-vue";

import { sendCode, loginApi } from "@/api/user";

import { getBigOrigin } from "@/utils/help";

defineProps({ open: Boolean });

// 表单
const loginFormRef = ref(null);
const formState = reactive({
  tel: "",
  code: "",
});

// 校验规则
function handleCheckPhone() {
  if (/^1[3456789]\d{9}$/.test(formState.tel)) {
    return Promise.resolve();
  } else if (!formState.tel) {
    return Promise.reject("请输入手机号");
  } else {
    return Promise.reject("请输入正确的手机号");
  }
}

function handleCheckCode() {
  if (/^\d{6}$/.test(formState.code)) {
    return Promise.resolve();
  } else if (!formState.code) {
    return Promise.reject("请输入验证码");
  } else {
    return Promise.reject("请输入正确的验证码");
  }
}

const btnText = ref("发送验证码");
const seconds = ref(120);
const codeSubmitFlag = ref(false);
let inter = null;
const _timer = () => {
  inter = setInterval(() => {
    seconds.value--;
    btnText.value = `${seconds.value}s后重新发送`;
    if (seconds.value <= 0) {
      clearInterval(inter);
      codeSubmitFlag.value = false;
      btnText.value = "发送验证码";
      seconds.value = 120;
    }
  }, 1000);
};
// 获取验证码
const handleSendCode = async () => {
  if (seconds.value < 120) {
    return;
  }
  loginFormRef.value.validateFields("tel").then(async () => {
    try {
      // const origin = getBigOrigin();
      const params = {
        phone: formState.tel,
        smsSource: "YM_BRAIN_HEALTH", //origin,
        type: "pcStudentLogin",
      };
      await sendCode(params);
      message.success("验证码发送成功");
      // 定时器
      _timer();
    } catch (error) {
      console.error(error);
      message.error("验证码发送失败");
    }
  });
};

const handleCancel = () => {
  loginFormRef.value.resetFields();
  store.commit("user/setPcLoginPop", false);
};
//提交表单
const handleSubmit = async () => {
  codeSubmitFlag.value = true;
  let origin = getBigOrigin();
  const params = {
    phone: formState.tel,
    code: formState.code,
    source: origin,
    platformId: store.getters["config/getConfig"].platformId,
  };
  try {
    const { results } = await loginApi(params);
    codeSubmitFlag.value = false;
    if (results.token) {
      localStorage.setItem("token", results.token.split(" ")[1]);
      store.commit("user/setUserInfo", results);
    }
    message.success("登录成功！");
    handleCancel();
  } catch (error) {
    codeSubmitFlag.value = false;
    message.success("登录失败！");
  }
};
</script>

<style lang="less">
.vcode-content {
  padding-top: 42px;
  .modal-login-title {
    height: 25px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #333;
    line-height: 25px;
    letter-spacing: 2px;
    text-align: center;
    margin-bottom: 35px;
  }
  .login-form {
    text-align: center;
  }
  .phone-input {
    width: 240px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #e3e3e3;
  }
  .code-wrapper {
    display: inline-flex;
    align-items: center;
    width: 240px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #e3e3e3;
    position: relative;
    .code-input {
      height: 100%;
    }
    .send-code {
      color: @theme-color;
    }
  }

  .btn {
    width: 240px;
    height: 36px;
    border-radius: 4px;
    background: @theme-color;
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    border: none;
    &:hover {
      background: @theme-color;
    }
  }
  .tip {
    margin: 36px 0 40px 0;
  }
}
</style>
